import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push,
  replace
} from 'react-router-redux';
import {
  Button,
  Container,
  Header,
  Icon,
  List,
  Menu,
  Modal,
  Segment
} from 'semantic-ui-react';
import {
  Link
} from 'react-router-dom';
import {
  Route
} from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import AList from './../../auto/AList';

const PAGE_RANGE = 10;

class RubrosView extends Component {

  constructor (props) {
    super(props);

    this.RubroService = this.props.feathers.service('/api/rubros');
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    return (
      <div>
        <AList
          pageRange={PAGE_RANGE}
          mapFunction={(rubro) => ({
            id: rubro.id,
            header: `${rubro.nombre}`
          })}
          service={this.RubroService}
          form={{
            fields: [
              ['!Nombre', 'nombre', 'input', 8]
            ],
            service: this.RubroService
          }} />
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    RubrosView.mapStateToProps,
    RubrosView.mapDispatchToProps
  )(RubrosView)
);



// WEBPACK FOOTER //
// ./client/components/pages/misc/RubrosView.js